import { filter, map } from 'rxjs/operators';

import { updatePrimaryColor } from '../theme';

export default class SnackbarAppBloc {
  constructor({ authRepository }) {
    this.authRepository = authRepository;
  }

  get theme$() {
    return this.authRepository.userWorkspace$.pipe(
      filter((workspace) => workspace),
      map((workspace) => {
        return updatePrimaryColor(workspace.primaryColor);
      })
    );
  }
}
